import { Stack } from '@mui/material';
import { type FlowCreateNotableObjectConfig, FlowNotableObject } from 'flow-schema';
import { type ComponentType } from 'react';

import { isDefined } from 'common';

import { CreateAuthorizationSubmissionsFormFields } from './FormFields/authorizationSubmissionsFormFields';
import { CreateEncounterFormFields } from './FormFields/encounterFormFields';
import { CreatePatientFormFields } from './FormFields/patientFormFields';
import { CreateServiceReviewSubmissionsFormFields } from './FormFields/serviceReviewSubmissionsFormFields';
import { BlockSelectField } from '../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

const CREATE_NOTABLE_OBJECT_FORM_FIELDS: Partial<Record<FlowNotableObject, ComponentType>> = {
  [FlowNotableObject.Encounter]: CreateEncounterFormFields,
  [FlowNotableObject.Patient]: CreatePatientFormFields,
  [FlowNotableObject.ServiceReviewSubmissions]: CreateServiceReviewSubmissionsFormFields,
  [FlowNotableObject.AuthorizationSubmissions]: CreateAuthorizationSubmissionsFormFields,
};

export function CreateNotableObjectFormFields() {
  const { value: notableObject } =
    useSelectedNodeField<FlowCreateNotableObjectConfig['notableObject']>('config.notableObject');
  const FormFields = isDefined(notableObject)
    ? CREATE_NOTABLE_OBJECT_FORM_FIELDS[notableObject]
    : undefined;
  return (
    <Stack gap={3}>
      <BlockSelectField
        label="Notable Object"
        fieldName="config.notableObject"
        required
        options={Object.keys(CREATE_NOTABLE_OBJECT_FORM_FIELDS).map((notableObject) => ({
          label: notableObject,
          value: notableObject,
        }))}
      />
      {isDefined(FormFields) && <FormFields />}
    </Stack>
  );
}
